module.exports = __webpack_public_path__ + "static/media/ExperiencedGuidePic.aa43d92a.png";